import { useHeaderConfig } from "@repo/api";
import { useSettings } from "@repo/ui";
import { useEffect, useState } from "react";

export const useShowSubHeader = () => {
  const { market, language } = useSettings();
  const {
    data: settings,
    isLoading,
    isValidating,
  } = useHeaderConfig(market, language);
  const [isSubHeaderVisible, setIsSubHeaderVisible] = useState(false);
  useEffect(() => {
    if (settings?.header_configs?.enable_second_level_header) {
      setIsSubHeaderVisible(true);
      window.salja?.salesLead?.showSubHeader?.(true);
    }
  }, [settings]);

  return { isSubHeaderVisible, isLoading, isValidating };
};

export const useHideSubHeader = () => {
  useEffect(() => {
    window.salja?.salesLead?.showSubHeader?.(false);
  }, []);
};
